import { SelectIntegrationForm } from "@/components/campaign/setup/delivery/SelectIntegrationForm";
import { Modal } from "@/components/generic/Modal";
import { SetupIntegrationModal } from "@/components/integrations/SetupIntegrationModal";
import { Campaign } from "@/types/campaign";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useCallback, useEffect, useState } from "react";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/delivery/integration/select/",
)({
  component: RouteComponent,
  staticData: {
    crumb: "Vælg integration",
    meta: {
      title: "Vælg integration",
    },
  },
  validateSearch: zodValidator(
    z.object({
      integration: z.string().optional(),
    }),
  ),
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const { integration } = Route.useSearch();
  const navigate = Route.useNavigate();
  const stepper = context.useStepper();
  const deliveryContext = stepper.context.delivery;
  if (deliveryContext?.type !== "Integration") throw null;

  const { exportSystem } = deliveryContext;

  const updateExportSystem = useCallback(
    (exportSystem: Campaign["exportSystem"]) => {
      stepper.setContext((prev) => {
        if (
          prev.delivery?.type !== "Integration" ||
          prev.delivery.exportSystem === exportSystem
        )
          return prev;
        return {
          ...prev,
          delivery: {
            ...prev.delivery,
            exportSystem,
            exportInput: null,
          },
        };
      });

      stepper.goNext();
    },
    [stepper],
  );

  useEffect(() => {
    if (integration) {
      updateExportSystem(integration);
    }
  }, []);

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <SelectIntegrationForm
      exportSystem={exportSystem}
      updateExportSystem={updateExportSystem}
      setSubmitHandler={setSubmitHandler}
      onSetupIntegration={() =>
        navigate({
          to: "/campaigns/setup/delivery/integration/select/new",
        })
      }
    />
  );
}
